import { render } from "./WidgetUserWelcome.vue?vue&type=template&id=edb72a0e&lang=html"
import script from "./WidgetUserWelcome.vue?vue&type=script&lang=js"
export * from "./WidgetUserWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__